import { Root, Viewport, Scrollbar, Thumb } from '@radix-ui/react-scroll-area';
import styled from 'styled-components';
import { COLOR_CI_BLUE } from '../../config';

const ScrollerContainer = styled.div`
    .ScrollerRoot {
        width: 100%;
        height: 35rem;
        overflow: hidden;
        --scrollbar-size: 0.3rem;
    }

    .ScrollerViewport {
        width: 100%;
        height: 100%;
        border-radius: inherit;
    }

    .ScrollerScrollbar {
        display: flex;
        /* ensures no selection */
        user-select: none;
        /* disable browser handling of all panning and zooming gestures on touch devices */
        touch-action: none;
        /* padding: 0.1rem; */
        background: white;
        /* transition: background 160ms ease-out; */
        box-shadow: 0 0.25rem 0.25rem 0 rgba(0,0,0,0.14);
        border: solid 0.15rem white;
        border-radius: 0.5rem;

        left: 35rem !important;
        right: 35rem !important;
        bottom: 1rem !important;
    }

    .ScrollerScrollbar[data-orientation='horizontal'] {
        flex-direction: column;
        height: var(--scrollbar-size);
    }

    .ScrollerThumb {
        flex: 1;
        background: ${COLOR_CI_BLUE};
        border-radius: var(--scrollbar-size);
        height: 100% !important;
        position: relative;
    }

    /* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */
    .ScrollerThumb::before {
    content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        min-width: 44px;
        min-height: 44px;
    }
`;

function UnstyledScroller(props: {children: any; className?: string | undefined; resetScrollKey?: string | undefined}) {
    return (
        <ScrollerContainer className={props.className}>
            <Root className="ScrollerRoot" type="always">
                <Viewport className="ScrollerViewport" key={props.resetScrollKey}>
                    {props.children}
                </Viewport>
                <Scrollbar className="ScrollerScrollbar" orientation="horizontal" key={Math.random().toString()}>
                    <Thumb className="ScrollerThumb" />
                </Scrollbar>
            </Root>
        </ScrollerContainer>
    );
}

export const Scroller = styled(UnstyledScroller)``;
